import React from 'react';
import PropTypes from 'prop-types';
import {
  required,
  translate as t,
} from 'admin-on-rest';
import BasicTextInput from '../Quiz/FormInputs/BasicTextInput';
import DialogForm from './DialogForm';
import IconPicker, { iconNameMap } from './IconPicker';
import FolderIcon from './FolderIcon';
import PositionPicker from './PositionPicker';
import UserPicker from './UserPicker';

const TRANSLATION_PREFIX = 'documents.directory';

const styles = {
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '100%',
    flex: 1,
  },
};

class FolderForm extends React.Component {
  state = {
    name: {
      errorText: null,
      touched: false,
    },
  }

  nameOnChange = (ev) => {
    const val = ev.target.value;
    this.change('name', val);
    this.setState({
      name: {
        errorText: required(val, null, this.props),
        touched: true,
      },
    });
  }

  descriptionOnChange = (ev) => {
    this.change('description', ev.target.value);
  }

  iconOnChange = (val) => {
    this.change('icon', val);
  }

  rolePermissionsOnChange = (roles) => {
    this.change('rolePermissions', roles);
  }

  userPermissionsOnChange = (users) => {
    this.change('userPermissions', users);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta);
  }

  render() {
    const {
      name, description, icon,
      open, translate,
      rolePermissions, userPermissions,
      users, roles, onSave, onClose,
    } = this.props;

    return (
      <DialogForm
        title={name}
        open={open}
        onSave={onSave}
        onClose={onClose}
        icon={
          <FolderIcon
            icon={iconNameMap[icon]}
          />
        }
      >
        <BasicTextInput
          type="text"
          value={name}
          onTouch={this.nameOnChange}
          errorText={this.state.name.touched && this.state.name.errorText}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.fields.name`)}
        />
        <BasicTextInput
          type="text"
          value={description}
          onChange={this.descriptionOnChange}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.fields.description`)}
        />
        <IconPicker
          label={translate(`${TRANSLATION_PREFIX}.fields.icon`)}
          onChange={this.iconOnChange}
          value={icon}
        />
        <h4 style={{ marginBottom: 0 }}>{translate('permissions')}</h4>
        <div style={styles.row}>
          <div style={styles.col}>
            <UserPicker
              label={translate(`${TRANSLATION_PREFIX}.userPermitted`)}
              selected={userPermissions}
              onChange={this.userPermissionsOnChange}
              users={users}
            />
          </div>
          <div style={styles.col}>
            <PositionPicker
              checked={rolePermissions}
              onChange={this.rolePermissionsOnChange}
              positions={roles}
            />
          </div>
        </div>
      </DialogForm>
    );
  }
}

FolderForm.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  open: PropTypes.bool,
  userPermissions: PropTypes.array,
  rolePermissions: PropTypes.array,
  users: PropTypes.array,
  roles: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default t(FolderForm);
